<template>
    <span>
        <template v-if="model.issueTimeShift">
            Issue invoice
            {{model.issueTimeShift.duration}}&nbsp;{{issueTimeShiftUnit}}
            {{model.issueTimeShift.chronology}}
            period change.
        </template>
        <template v-if="model.dueTimeShift">
            Shift the due time to
            {{model.dueTimeShift.duration}}&nbsp;{{dueTimeShiftUnit}}
            after issue.
        </template>
    </span>
</template>
<script>
    import _ from '@/common/helpers/index';

    export default {
        name: 'invoice-time-shift-preview',
        props: {
            model: {
                type: Object, // InvoiceTimeShiftModel
                required: true,
            },
        },
        computed: {
            issueTimeShiftUnit() {
                const shift = this.model.issueTimeShift;
                return _.pluralize(shift.unit, shift.duration);
            },
            dueTimeShiftUnit() {
                const shift = this.model.dueTimeShift;
                return _.pluralize(shift.unit, shift.duration);
            },
        },
    };
</script>
